module.exports = __webpack_public_path__ + "img/ke-pan.9de6b407.png";